import {Component, Injectable, OnDestroy} from '@angular/core';
import {
    dynamicModalAbstractInterface,
    dynamicModalAbstractOverrideInterface
} from '../interfaces/dynamic-modal-abstract.interface';
import {DynamicModalLoaderService} from '../services/dynamic-modal-loader.service';
import {TunnelResult} from './tunnel-result';
import {EmitType} from '../constants/emit-types.enum';
import {EmitterTypes} from '../constants/emitter-types.enum';
import {Subscription} from 'rxjs';

@Component({
    template: ''
})

export abstract class DynamicModalAbstractComponent implements dynamicModalAbstractInterface,
                                                                dynamicModalAbstractOverrideInterface, OnDestroy {

  protected constructor(protected dynamicModalLoader: DynamicModalLoaderService) {
  }
  public backdropAllowed: boolean = true;

  observableInstance$: Subscription;
  observableName: string;

  abstract onNext(payload): void;

  abstract onError(error): void;

  abstract onComplete(): void;

  subscribe(observableName: string): void {
    this.observableName = observableName;
    this.observableInstance$ = this.dynamicModalLoader.getObservable(this.observableName, true).subscribe(
      (next) => {
        const payload = next && next.hasOwnProperty('payload') ? next['payload'] : next;
        this.onNext(payload);
      },
      err => {
        this.onError(err);
      },
      () => {
        this.dismiss(false);
        this.onComplete();
      }
    );
  }

  /**
   * dismiss the modal and emit
   *
   * @param {boolean} shouldEmitPayload
   * @param any payload
   */
  dismiss(shouldEmitPayload: boolean = false, payload?: any): void {
    const payloadData = new TunnelResult(EmitterTypes.parent, shouldEmitPayload ? EmitType.Data : EmitType.Dismiss, payload);
    this.dynamicModalLoader.dismissObservable(this.observableName, shouldEmitPayload, payloadData);
  }

  close(data, isButton: boolean = true) {
    if (!isButton && !this.backdropAllowed) {
      return;
    }
    let status;
    if (typeof data === 'object' && data.status) {
      status = data.status || 1;
    } else {
      status = data;
    }
    this.dismiss(status, data);
  }
  ngOnDestroy(): void {
    this.dismiss(true, null);
    if (this.observableInstance$) {
      this.observableInstance$.unsubscribe();
    }
  }

}
